<template>
  <div class="conversation-details">
    <!-- Szczegóły produktu -->
    <new-messenger-conversation-details-item v-if="ticket.op" :title="$t('newMessenger.productDetails')">
      <div v-if="$store.state.websocket.loadingTicket" class="collapse-content">
        <b-skeleton />
      </div>
      <div v-else class="collapse-content">
        <div class="content-photo">
          <b-image
            v-if="ticket.op.mainImage"
            ratio="1by1"
            :src="getImageBySize(ticket.op.mainImage.file, 'big').src"
            :webp-fallback="getImageBySize(ticket.op.mainImage.file, 'big').webpFallback"
            :alt="ticket.op.mainImage.name"
            class="skeleton-image-placeholder"
            lazy
          >
            <template #placeholder>
              <b-skeleton />
            </template>
          </b-image>
        </div>
        <div v-if="ticket.op.product && ticket.op.product.description" class="content-title">
          {{ ticket.op.product.description.name }}
        </div>
        <div v-if="ticket.op.summary" class="content-price">
          {{ toCurrency(ticket.op.summary.price, '', ticket.op.summary.currency) }}
        </div>
        <div v-if="ticket.op.shippingInfo" class="content-delivery ">
          <b-icon icon="package-variant" />
          {{ $t('products.shippingInfo.deliveryTime', { time: getDeliveryTime(ticket.op.shippingInfo.deliveryTime) }) }}
        </div>
        <div class="content-button">
          <b-button expanded type="is-primary" outlined @click="seeProduct()">
            {{ $t('newMessenger.seeProduct') }}
          </b-button>
        </div>
      </div>
    </new-messenger-conversation-details-item>

    <!-- Szczegóły zamówienia -->
    <new-messenger-conversation-details-item v-if="ticket.order" :title="$t('newMessenger.orderDetails')">
      <div v-if="$store.state.websocket.loadingTicket" class="collapse-content">
        <b-skeleton />
      </div>
      <div v-else class="collapse-content">
        <div class="content-orders">
          <new-messenger-conversation-details-order :order="ticket.order" />
        </div>
        <div class="content-button">
          <b-button expanded type="is-primary" outlined @click="seeOrder(ticket.order)">
            {{ $t('newMessenger.seeOrder') }}
          </b-button>
        </div>
      </div>
    </new-messenger-conversation-details-item>

    <!-- Szczegóły rekomendowaych produktów -->
    <!-- <new-messenger-conversation-details-item :title="$t('newMessenger.recommendedProducts')">
      <div class="collapse-content">
        <div class="content-produkts">
          Tutaj polecane proukty, widoczne przy ogólnym zapytaniu do sklepu
        </div>
        <div class="content-button">
          <b-button expanded type="is-primary" outlined>
            {{ $t('newMessenger.seeProducts') }}
          </b-button>
        </div>
      </div>
    </new-messenger-conversation-details-item> -->
    <b-button icon-left="arrow-left" class="conversation-details-icon" @click="emitCloseDetails" />
  </div>
</template>

<script>
import NewMessengerConversationDetailsItem from '../NewMessengerConversationDetailsItem.vue'
import NewMessengerConversationDetailsOrder from '../NewMessengerConversationDetailsOrder.vue'
import toSlugText from '~/marketplace-front-core/utils/toSlugText'

export default {
  name: 'NewMessengerConversationDetails',
  components: {
    NewMessengerConversationDetailsItem,
    NewMessengerConversationDetailsOrder
  },
  props: {
    ticket: {
      type: Object,
      default: null
    }
  },
  computed: {
    isSeller () {
      return !this.$store.state.auth.user?.roles.includes('ROLE_USER')
    }
  },
  methods: {
    emitCloseDetails () {
      this.$emit('closeDetails')
    },
    seeOrder (data) {
      const routerPath = this.$router.resolve(this.localePath({
        name: 'profile-orders-id',
        params: { id: data.id }
      }))
      window.open(routerPath.href, '_blank')
    },
    seeProduct () {
      const routerPath = this.$router.resolve(this.localePath({
        name: 'product',
        params: {
          productName: toSlugText(this.ticket.op.description.name),
          productId: this.ticket.op.id
        }
      }))
      window.open(routerPath.href, '_blank')
    },
    getDeliveryTime (deliveryTime) {
      let range = null
      if (deliveryTime) {
        const start = deliveryTime.start
        const end = deliveryTime.end
        if (this.$moment(start).isSame(end, 'year')) {
          if (this.$moment(start).isSame(end, 'month')) {
            if (this.$moment(start).isSame(end, 'day')) {
              range = this.$moment(start).format('dddd, DD MMM')
            } else { range = this.$moment(start).format('DD') + ' - ' + this.$moment(end).format('DD MMM') }
          } else { range = this.$moment(start).format('DD MMM') + ' - ' + this.$moment(end).format('DD MMM') }
        } else { range = this.$moment(start).format('DD.MM.YYYY') + ' - ' + this.$moment(end).format('DD.MM.YYYY') }
      }
      return range
    }
  }
}
</script>

<style lang="scss" scoped>
$messenger-border-color: #E7E8E7;
$messanger-delivery-color: #179644;
$messanger-content-client-color: #909090;

.card-header-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.conversation-details {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden auto;

  .collapse-content {
    padding: 16px;

    .content-title {
      margin-top: 16px;
      font-weight: 600;
    }

    .content-photo {
      width: 100%;
    }

    .content-price {
      margin-top: 16px;
      margin-bottom: 8px;
      font-weight: 600;
      font-size: 22px;

      span {
        font-size: 18px;
        font-weight: 300;
      }
    }

    .content-delivery {
      display: flex;
      justify-content: flex-start;
      font-size: 14px;
      color: $messanger-delivery-color;
      gap: 0 10px;
    }

    .content-client {
      .content-client-data {
        font-size: 14px;
        color: $messanger-content-client-color ;
      }
    }

    .content-button {
      margin: 10px 0;
    }
  }

  .conversation-details-icon {
    position: fixed;
    bottom: 40px;
    left: calc(50% - 20px);
    display: none;
    width: 40px;
    height: 40px;
    border-radius: 20px;
    z-index: 10;

    @include touch {
      display: inline-flex;
    }

    :deep(.icon)>i {
      font-size: 18px !important;
    }
  }
}</style>
